export default __webpack_public_path__ + "static/media/sj-3-rMAX.b009fb76.avif";